export const Footer = () => (
  <footer className="border-t border-[#27303E] mt-16 md:mt-24 pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0" data-testid="site-footer">
    <div className="hazard h-1.5 opacity-80" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row justify-between gap-4">
      <p className="font-display text-xl uppercase font-bold">Gear<span className="text-amber-500">Head</span> Repair Desk</p>
      <p className="text-sm text-slate-500 max-w-xl">
        Information is for general guidance only. Always follow your vehicle's service manual and consult a certified
        technician for safety-critical repairs like brakes, steering, and fuel systems.
      </p>
    </div>
  </footer>
);
